import { ia, objMap } from 'lib/helpers/utility';

export const DEFAULT_COLUMN_DEFS = {
  resizable: true,
  // flex: 1,
  suppressSizeToFit: true
};

export const AUTO_SIZE_STRATEGY = {
  type: 'fitGridWidth'
};

export const labelToKey = (label) => {
  return label
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
};

export const DEFAULT_CUSTOM_REPORT = {
  header: {
    logo: true,
    practiceName: true,
    reportPeriod: true,
    reportTitle: true
  }
};

export const applyFilters = (prev, reportFilters) => {
  try {
    const currentFilters = { ...prev };

    const filledFilters = objMap(reportFilters, (key, filter) => {
      if (currentFilters[key]) {
        return filter.map((f) => ({ ...currentFilters[key], ...f }));
      }
    });
    return filledFilters;
  } catch (error) {
    const defaultOnlyFilters = {};
    Object.keys(prev).forEach((key) => {
      if (prev[key]?.default) {
        defaultOnlyFilters[key] = [prev[key]];
      }
    });
    return defaultOnlyFilters;
  }
};

export const expandCollapseNodes = async (gridRef, expanded) => {
  gridRef.current.api.forEachNode((node) => {
    if (node && ia(node.data.children)) {
      node.setExpanded(!expanded);
    }
  });
};

export const checkForNestedChildren = (data) => {
  const hasNested = data?.find((el) => {
    return el?.children?.some((nestedChild) => nestedChild?.children?.length);
  });

  if (!hasNested) {
    return data?.find((el) => el?.children?.length);
  }

  return hasNested;
};
